module.exports = __webpack_public_path__ + "img/nuxt.358270d.jpg";